export default __webpack_public_path__ + "static/media/hiw-c.afafba08.svg";